import actions from "./actions.js";
import getters from "./getters.js";
import mutations from "./mutations.js";

export default {
    namespaced: true,
    state() {
        return {
            feedList: [],
            foxPages: [],
            emojiList: [],
            feedNotes: [],
            foxData: null,
            repyDrafts: [],
            foxHistory: [],
            feedAnswers: [],
            foxChannels: [],
            foxComments: [],
            attachments: [],
            feedAnswer: null,
            misspellList: [],
            answerAudit: null,
            answerAuditEnabled: false,
            foxFeedbacks: [],
            workspaceTags:[],
            foxCategories: [],
            foxTaskTitles: [],
            foxReplytypes: [],
            feederHistory: [],
            cepDefinition: "",
            cepDefinitionWorkspaceId: null,
            feedsToBeMasked: [],
            foxRelatedFeeds: [],
            totalHistoryCount: 0,
            replySuggestions: [],
            moderationReason: [],
            foxPreviousReply: "",
            commentHistory: null,
            checkAnswerRules: {},
            checkAnswerCount: [],
            selectedReplyText: "",
            foxGsmTypeOptions: [],
            emojisIsEnabled: true,
            dynamicsCountryList: [],
            feedsCannotBeUnmasked: [],
            registeredSocialAccounts: [],
            checkAnswerCountCopyTable: null,
            feedsAlreadyMarkedForMasking: []
        }
    },
    getters,
    actions,
    mutations
}